<template>
    <v-list-tile>
        <v-list-tile-content>
            {{ label }}
        </v-list-tile-content>
        <v-list-tile-action>
            <v-icon v-if="status === 'success'">done</v-icon>
            <v-progress-circular
                    v-if="status === 'inProgress'"
                    indeterminate
                    color="primary"
            ></v-progress-circular>
            <v-icon v-if="status === 'error'">error</v-icon>
        </v-list-tile-action>
    </v-list-tile>
</template>

<script>
    export default {
        name: "BuildingStep.vue",
        props: {
            status: {
                type: String,
            },
            label: {
                type: String,
            },
        }
    }
</script>

<style scoped>

</style>
